import { render } from "./ImportProductosPrioridad.vue?vue&type=template&id=05066cec"
import script from "./ImportProductosPrioridad.vue?vue&type=script&lang=js"
export * from "./ImportProductosPrioridad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__